export default __webpack_public_path__ + "static/media/AddWmsPanel.8c31daaf.less";